const report = {
  title: 'Povijest',
  sections: 'Odjeljci',
  noReports: 'Još nema medicinskih izvještaja',
  noReportsDescription: 'Kreirajte svoj prvi medicinski izvještaj za početak.',
  noReportsSearch: 'Nema izvještaja za "{{searchQuery}}"',
  noReportsSearchDescription: 'Pokušajte s drugačijim upitom.',
  createReport: 'Kreiraj izvještaj',
  searchPlaceholder: 'Pretraži izvještaje...',
  section_one: '{{count}} odjeljak',
  section_other: '{{count}} odjeljaka',
  loading: 'Učitavanje...',
  deleteConfirm:
    'Jeste li sigurni da želite obrisati ovaj medicinski izvještaj?',
  deleteConfirmTitle: 'Obriši izvještaj',
  deleteConfirmDescription:
    'Jeste li sigurni da želite obrisati "{{name}}"? Ova radnja se ne može poništiti.',
  delete: 'Obriši',
  invalidReportId: 'Neispravan ID izvještaja',
  reportNotFound: 'Izvještaj nije pronađen',
  patientName: 'Naslov izvještaja',
  patientNamePlaceholder: 'Ime pacijenta (Razlog posjeta)',
  addSection: 'Dodaj odjeljak',
  noSections: 'Nema odjeljaka. Dodajte prvi odjeljak za početak.',
  sectionTitle: 'Naslov odjeljka',
  sectionTitlePlaceholder: 'Glavna tegoba, Status',
  sectionContent: 'Sadržaj odjeljka',
  sectionContentPlaceholder: 'Unesite sadržaj odjeljka...',
  save: 'Spremi',
  cancel: 'Odustani',
  generateReport: 'Generiraj izvještaj',
  reportGenerated: 'Izvještaj uspješno generiran',
  report: 'Izvještaj',
  downloadPdf: 'Preuzmi PDF',
  downloadDocx: 'Preuzmi DOCX',
  pdfPreview: 'Pregled PDF-a',
  previewReport: 'Pregledaj izvještaj',
  viewTranscription: 'Pogledaj transkripciju',
  reportActions: 'Radnje izvještaja',
  separator: ' • ',
  reportUpdated: 'Izvještaj ažuriran',
  deletedSuccessfully: 'Izvještaj uspješno obrisan',
  download: 'Preuzmi',
  downloading: 'Preuzimanje',
  regenerate: 'Ponovno generiraj dokument',
  regenerateDescription: 'Generiraj nove PDF i Word datoteke',
  saving: 'Spremanje…',
  generatingPreview: 'Ažuriranje pregleda…',
  saved: 'Promjene spremljene',
  saveChangesFirst: 'Prvo spremite promjene',
  copyReport: 'Kopiraj izvještaj',
  copyReportSuccess: 'Kopirano!',
  copyReportError: 'Nije moguće kopirati izvještaj',
  status: {
    draft: 'Skica',
    recording: 'Snimanje',
    processing: 'Obrada',
    generating: 'Generiranje',
    completed: 'Završeno',
    prepared: 'Pripremljeno',
    transcribing: 'Prepisivanje',
    error: 'Greška',
  },
  validation: {
    patientNameRequired: 'Naslov izvještaja je obavezan',
    atLeastOneSectionRequired: 'Potreban je barem jedan odjeljak',
    sectionTitleRequired: 'Naslov odjeljka je obavezan',
    sectionContentRequired: 'Sadržaj odjeljka je obavezan',
  },
  reopenForRecording: 'Snimaj ponovo',
  reopenConfirmTitle: 'Ponovno otvoriti izvještaj?',
  reopenConfirmDescription:
    'Izvještaj će se vratiti u skicu. Možete snimiti dodatni audio i ponovno generirati dokument.',
  reopenConfirm: 'Ponovno otvori',

  customIntegrations:
    'Za prilagođene predloške dokumenata i softverske integracije, kontaktirajte nas na ',

  errors: {
    notFound: 'Izvještaj nije pronađen',
    processingFailed: 'Obrada nije uspjela',
    processingFailedDescription:
      'Došlo je do pogreške tijekom obrade izvještaja. Molimo pokušajte ponovno.',
    tryAgainLater: 'Molimo pričekajte malo i pokušajte ponovno kasnije.',
    retry: 'Pokušaj ponovno',
  },
};

export default report;
